module.exports = __webpack_public_path__ + "static/media/PIJL_05.1bd2340a.png";